import React, { forwardRef } from "react";

export interface ProgramFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  fullWidth?: boolean;
  containerClassName?: string;
}

const ProgramField = forwardRef<HTMLInputElement, ProgramFieldProps>(
  (
    {
      label,
      error,
      fullWidth = false,
      containerClassName = "",
      className = "",
      id,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={`mb-4 ${
          fullWidth ? "w-full" : "w-full md:w-1/2"
        } pr-4 ${containerClassName}`}
      >
        <label className="block text-[#607D8B] text-sm mb-2" htmlFor={id}>
          {label}
        </label>
        <input
          id={id}
          ref={ref}
          className={`border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium rounded-[8px] px-3 py-2 transition-colors ${
            error ? "border-red-400 bg-red-50/40" : "border-[#E0E4EC]"
          } ${className}`}
          {...props}
        />
        {error && (
          <p className="text-xs text-red-500 mt-1 font-gilroy-medium">
            {error}
          </p>
        )}
      </div>
    );
  }
);

ProgramField.displayName = "ProgramField";

export default ProgramField;
